import Page from "../common/page";
import ScrollPin from "../lib/scroll/scroll-pin";
import MotionOeraStoryScrollSvg from "../lib/motion-oera-story-scroll-svg";
import MotionScrollTxt from "../lib/motion-scroll-txt";
import MotionScrollBox from "../lib/motion-scroll-box";
import {scrollSetting} from "../common/globalVars";
import MotionOeraStoryTech from "../lib/motion-oera-story-tech";
import MotionScrollProduct from "../lib/motion-scroll-product";
import Parallax from "../common/parallax";

export default class PageOeraStory extends Page {
    setPage() {
        new ScrollPin(this.el.querySelector('.sec-2'), this.el.querySelector('.sec-2 .txt-holder'));

        new Parallax(
            [
                {el: '.sec-1 .pos-box article', tX:0, tY:()=>{
                        return window.innerHeight/8 *-1;
                    }, tS:1}
            ]
        );

        new MotionOeraStoryScrollSvg(
            this.el.querySelector('.sec-2'),
            this.el.querySelector('.sec-2 .svg-holder'),
            this.el.querySelector('.sec-2 .svg-holder .st0'),
            [
                this.el.querySelector('.sec-2 .txt-holder .txt-box-1'),
                this.el.querySelector('.sec-2 .txt-holder .txt-box-2'),
                this.el.querySelector('.sec-2 .txt-holder .txt-box-3'),
                this.el.querySelector('.sec-2 .txt-holder .txt-box-4')
            ],
            this.el.querySelector('.sec-2 .line-holder.bottom .line'),
            6000,
            false
        );

        new MotionScrollProduct(
            this.el.querySelector('.sec-6 .component-scroll-holder')
        );

        new MotionOeraStoryTech(this.el.querySelector('.sec-5 .tech-1'));
        new MotionOeraStoryTech(this.el.querySelector('.sec-5 .tech-2'));
        new MotionOeraStoryTech(this.el.querySelector('.sec-5 .tech-3'));

        if (!scrollSetting.smooth) {
            this.setSticky();
        }


    }

    setSticky() {
        let stickyEl = this.el.querySelector('.sticky-holder');
        stickyEl.style.position = 'sticky';
        stickyEl.parentNode.style.display = 'block';
    }
}
